import React from 'react';
import { useRouter } from 'next/router';
import { Typography, Box } from '@mui/material';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { CheckoutParamEnum } from 'components/views/pages/Checkout/types';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';

interface Props {
  isLoading: boolean;
}

export const CheckoutGatewayClosed = ({ isLoading }: Props) => {
  const router = useRouter();

  const onClickEditTripDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, [CheckoutParamEnum.step]: 1, scrollToMessage: 'true' },
      },
      undefined,
      {
        shallow: true,
        scroll: false,
      },
    );
  };

  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <CheckoutSectionTitle>Request to Book Property</CheckoutSectionTitle>
        </Box>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading}>
        <Typography variant="body1">
          This property host has asked to review and approve all booking requests before confirmation. On approval, you will receive an email notification to confirm the reservation payment.
          <br />
          <br />
          <strong>Tip:</strong> More information about your trip and group in the{' '}
          <strong>&quot;Message to the host&quot;</strong> will greatly increase the acceptance rate{' '}
          <a href="#" onClick={onClickEditTripDetails}>
            (Click here to review your message)
          </a>
        </Typography>
      </LoadingSkeleton>
    </Grid>
  );
};

